// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Guide_create-project-container__j6x4y {
  max-width: 1100px;
  margin: 0 auto;
  padding: 2rem;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.Guide_create-project-container__j6x4y h1 {
  font-size: 2.2rem;
  margin-bottom: 0.5rem;
}

.Guide_create-project-container__j6x4y p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  color: #555;
}

.Guide_method-selector-grid__ZkpDh {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.Guide_method-card__b6\\+0a {
  background-color: #fdf6e3;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.Guide_method-card__b6\\+0a:nth-child(2n) {
  background-color: #e3f6f5;
}

.Guide_method-card__b6\\+0a:nth-child(3n) {
  background-color: #f3e5f5;
}

.Guide_method-card__b6\\+0a:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.Guide_method-icon__RNEnd {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  text-align: center;
}

.Guide_method-card__b6\\+0a h3 {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  text-align: center;
}

.Guide_method-card__b6\\+0a p {
  font-size: 0.95rem;
  color: #333;
  flex-grow: 1;
  text-align: center;
}

.Guide_method-card-buttons__eCQ9N {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
  gap: 0.5rem;
}

.Guide_method-card-buttons__eCQ9N button {
  flex: 1 1;
  padding: 0.5rem;
  font-size: 0.9rem;
  background-color: #ffffffaa;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.Guide_method-card-buttons__eCQ9N button:hover {
  background-color: #ffffff;
}

.Guide_detail-level-selector__iu-gu {
  margin-top: 2rem;
  text-align: center;
}

.Guide_detail-level-selector__iu-gu h2 {
  margin-bottom: 1rem;
}

.Guide_level-buttons__p0tEk {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.Guide_level-buttons__p0tEk button {
  min-width: 180px;
  padding: 1rem;
  border: none;
  border-radius: 10px;
  background-color: #e0e0e0;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.Guide_level-buttons__p0tEk button:hover {
  background-color: #d5d5d5;
  transform: translateY(-2px);
}

.Guide_form-dynamic-renderer__zyqOe .Guide_form-group__f9cLe {
  margin-bottom: 1.5rem;
}

.Guide_form-dynamic-renderer__zyqOe label {
  display: block;
  font-weight: bold;
  margin-bottom: 0.3rem;
}

.Guide_form-dynamic-renderer__zyqOe input,
.Guide_form-dynamic-renderer__zyqOe textarea {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.Guide_pdf-preview__LJgk2 {
  margin-top: 2rem;
  text-align: right;
}

.Guide_modal-overlay__eq2bP {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.Guide_modal-content__vuWXA {
  background: #fff;
  padding: 2rem 2.5rem;
  border-radius: 14px;
  max-width: 650px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.Guide_modal-content__vuWXA h2 {
  font-size: 1.6rem;
  margin-bottom: 0.5rem;
}

.Guide_modal-content__vuWXA h3 {
  font-size: 1.2rem;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}

.Guide_modal-content__vuWXA ul {
  padding-left: 1.2rem;
  margin-top: 0.3rem;
  color: #444;
}

.Guide_modal-content__vuWXA p {
  line-height: 1.6;
  margin-top: 0.4rem;
  font-size: 0.95rem;
  color: #333;
}

.Guide_modal-close__BXzaP {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.3rem;
  cursor: pointer;
}

@media (max-width: 600px) {
  .Guide_method-card-buttons__eCQ9N {
    flex-direction: column;
    gap: 0.5rem;
  }

  .Guide_level-buttons__p0tEk {
    flex-direction: column;
  }

  .Guide_modal-content__vuWXA {
    padding: 1.5rem;
  }
}

.Guide_form-dynamic-renderer__zyqOe {
  margin-top: 2rem;
}

.Guide_form-dynamic-renderer__zyqOe h2 {
  font-size: 1.8rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #1a1a1a;
}

.Guide_form-section__xn00l {
  margin-bottom: 3rem;
  padding: 1.5rem;
  border-radius: 12px;
  background: #f9f9fb;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.Guide_form-section__xn00l h3 {
  font-size: 1.4rem;
  margin-bottom: 0.5rem;
  color: #004c6d;
  text-align: center;
  background: #e0f4ff;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
}

.Guide_section-description__rxDO2 {
  margin: 0.5rem auto 1.5rem;
  font-size: 0.95rem;
  color: #555;
  text-align: center;
  max-width: 600px;
}

.Guide_form-group__f9cLe {
  margin-bottom: 1.5rem;
}

.Guide_form-group__f9cLe label {
  display: block;
  font-weight: bold;
  margin-bottom: 0.3rem;
  color: #222;
}

.Guide_form-group__f9cLe input,
.Guide_form-group__f9cLe textarea {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.95rem;
  background: #fff;
}

.Guide_form-group__f9cLe textarea {
  min-height: 100px;
  resize: vertical;
}

.Guide_pdf-preview__LJgk2 {
  margin-top: 2rem;
  display: flex;
  gap: 1rem;
  align-items: center;
}

@media (max-width: 600px) {
  .Guide_form-section__xn00l h3 {
    font-size: 1.2rem;
  }

  .Guide_section-description__rxDO2 {
    font-size: 0.9rem;
  }

  .Guide_pdf-preview__LJgk2 {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composant/container/Ressources/Guide/Guide.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qDAAqD;EACrD,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".create-project-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 2rem;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.create-project-container h1 {\n  font-size: 2.2rem;\n  margin-bottom: 0.5rem;\n}\n\n.create-project-container p {\n  font-size: 1.1rem;\n  margin-bottom: 2rem;\n  color: #555;\n}\n\n.method-selector-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n}\n\n.method-card {\n  background-color: #fdf6e3;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.method-card:nth-child(2n) {\n  background-color: #e3f6f5;\n}\n\n.method-card:nth-child(3n) {\n  background-color: #f3e5f5;\n}\n\n.method-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.method-icon {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.method-card h3 {\n  font-size: 1.2rem;\n  margin-bottom: 0.5rem;\n  text-align: center;\n}\n\n.method-card p {\n  font-size: 0.95rem;\n  color: #333;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.method-card-buttons {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n  gap: 0.5rem;\n}\n\n.method-card-buttons button {\n  flex: 1;\n  padding: 0.5rem;\n  font-size: 0.9rem;\n  background-color: #ffffffaa;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.method-card-buttons button:hover {\n  background-color: #ffffff;\n}\n\n.detail-level-selector {\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.detail-level-selector h2 {\n  margin-bottom: 1rem;\n}\n\n.level-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.level-buttons button {\n  min-width: 180px;\n  padding: 1rem;\n  border: none;\n  border-radius: 10px;\n  background-color: #e0e0e0;\n  font-weight: bold;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.2s ease, transform 0.2s ease;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.05);\n}\n\n.level-buttons button:hover {\n  background-color: #d5d5d5;\n  transform: translateY(-2px);\n}\n\n.form-dynamic-renderer .form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-dynamic-renderer label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 0.3rem;\n}\n\n.form-dynamic-renderer input,\n.form-dynamic-renderer textarea {\n  width: 100%;\n  padding: 0.6rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n}\n\n.pdf-preview {\n  margin-top: 2rem;\n  text-align: right;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: #fff;\n  padding: 2rem 2.5rem;\n  border-radius: 14px;\n  max-width: 650px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n}\n\n.modal-content h2 {\n  font-size: 1.6rem;\n  margin-bottom: 0.5rem;\n}\n\n.modal-content h3 {\n  font-size: 1.2rem;\n  margin-top: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.modal-content ul {\n  padding-left: 1.2rem;\n  margin-top: 0.3rem;\n  color: #444;\n}\n\n.modal-content p {\n  line-height: 1.6;\n  margin-top: 0.4rem;\n  font-size: 0.95rem;\n  color: #333;\n}\n\n.modal-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 1.3rem;\n  cursor: pointer;\n}\n\n@media (max-width: 600px) {\n  .method-card-buttons {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .level-buttons {\n    flex-direction: column;\n  }\n\n  .modal-content {\n    padding: 1.5rem;\n  }\n}\n\n.form-dynamic-renderer {\n  margin-top: 2rem;\n}\n\n.form-dynamic-renderer h2 {\n  font-size: 1.8rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  color: #1a1a1a;\n}\n\n.form-section {\n  margin-bottom: 3rem;\n  padding: 1.5rem;\n  border-radius: 12px;\n  background: #f9f9fb;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);\n}\n\n.form-section h3 {\n  font-size: 1.4rem;\n  margin-bottom: 0.5rem;\n  color: #004c6d;\n  text-align: center;\n  background: #e0f4ff;\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.section-description {\n  margin: 0.5rem auto 1.5rem;\n  font-size: 0.95rem;\n  color: #555;\n  text-align: center;\n  max-width: 600px;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 0.3rem;\n  color: #222;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 0.6rem;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  background: #fff;\n}\n\n.form-group textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.pdf-preview {\n  margin-top: 2rem;\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n@media (max-width: 600px) {\n  .form-section h3 {\n    font-size: 1.2rem;\n  }\n\n  .section-description {\n    font-size: 0.9rem;\n  }\n\n  .pdf-preview {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"create-project-container": `Guide_create-project-container__j6x4y`,
	"method-selector-grid": `Guide_method-selector-grid__ZkpDh`,
	"method-card": `Guide_method-card__b6+0a`,
	"method-icon": `Guide_method-icon__RNEnd`,
	"method-card-buttons": `Guide_method-card-buttons__eCQ9N`,
	"detail-level-selector": `Guide_detail-level-selector__iu-gu`,
	"level-buttons": `Guide_level-buttons__p0tEk`,
	"form-dynamic-renderer": `Guide_form-dynamic-renderer__zyqOe`,
	"form-group": `Guide_form-group__f9cLe`,
	"pdf-preview": `Guide_pdf-preview__LJgk2`,
	"modal-overlay": `Guide_modal-overlay__eq2bP`,
	"modal-content": `Guide_modal-content__vuWXA`,
	"modal-close": `Guide_modal-close__BXzaP`,
	"form-section": `Guide_form-section__xn00l`,
	"section-description": `Guide_section-description__rxDO2`
};
export default ___CSS_LOADER_EXPORT___;
